// src/components/LatestProducts.js
import React, { useState, useEffect } from 'react';
import { Container, Typography, Grid, Paper, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import axiosInstance from '../services/api';
import { getFullImageUrl } from '../utils/urlHelpers';
import { slugify } from '../utils/slugify';

const LatestProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchLatestProducts = async () => {
      try {
        const response = await axiosInstance.get('/products');
        console.log("API Products:", response.data);
        // Filtreleme: status truthy olan tüm ürünler
        const activeProducts = response.data.filter(product => product.status);
        // createTime'e göre azalan sırada sıralama
        const sortedProducts = activeProducts.sort(
          (a, b) => new Date(b.createTime) - new Date(a.createTime)
        );
        setProducts(sortedProducts.slice(0, 6));
      } catch (error) {
        console.error("Error fetching latest products", error);
      }
    };

    fetchLatestProducts();
  }, []);

  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" sx={{ mb: 4, textAlign: 'center' }}>
        Yeni Eklenen Ürünler
      </Typography>
      {products.length === 0 ? (
        <Typography variant="body1" textAlign="center">
          Hiç ürün bulunamadı.
        </Typography>
      ) : (
        <Grid container spacing={4}>
          {products.map((product) => {
            const productUrl = `/product/${product.id}-${slugify(product.name)}`;
            return (
              <Grid item xs={12} sm={4} key={product.id}>
                <Paper sx={{ p: 2, textAlign: 'center', boxShadow: 3 }}>
                  {product.imageUrl && (
                    <img
                      src={getFullImageUrl(product.imageUrl)}
                      alt={product.name}
                      style={{
                        width: '100%',
                        height: '150px',
                        objectFit: 'cover',
                        marginBottom: '1rem'
                      }}
                    />
                  )}
                  <Typography variant="h6" gutterBottom>
                    {product.name}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    {product.description}
                  </Typography>
                  <Button variant="contained" color="primary" component={Link} to={productUrl}>
                    Detaylar
                  </Button>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      )}
    </Container>
  );
};

export default LatestProducts;
